import MediaQuery from 'react-responsive';
import React, { Component, PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { globalStyles } from 'styles/globalStyles';
import _ from 'lodash';

function getStyles(width, leftover) {
  let totalWidth = width + leftover + '%';
  return _.assign({}, globalStyles.cell, { width: totalWidth });
}

function removeLeadingZero(string) {
  var stringForReturn = string.replace(/^[0:]+/g,'');
  var splittedString = stringForReturn.split('');
  if(splittedString[0] === '0' || splittedString[0] === ':') {
    stringForReturn = stringForReturn.replace(/^[0:]+/g,'');
  }
  return stringForReturn;
}

export class Entry extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired
  };

  render() {
    const { data, settings, panelSettings } = this.props;
    const lineHeight = (parseInt(panelSettings.line_height * panelSettings.font_size) || 24) + 'px';
    const rowClass = (data.rank % 2 === 0  ? 'even' : 'odd') + (data.isLast ? ' lastEntry' : '');
    let time = removeLeadingZero(data.time)
    let pace = data.pace ? removeLeadingZero(data.pace) : '-';
    let bracketName = data.bracket_name || '';
    let bracketRank = data.bracket_rank || '';
    let showBracket = _.isUndefined(settings.show_bracket_rank) || settings.show_bracket_rank == 1;
    let showPace    = _.isUndefined(settings.show_pace) || settings.show_pace == 1;
    let showGender  = !_.isUndefined(settings.show_gender) && settings.show_gender == 1;
    let sex         = _.isUndefined(data.sex) || data.sex == 'NOT SPECIFIED' ? '--' : data.sex;
    let isCenter    = !_.isUndefined(panelSettings.center_columns) && panelSettings.center_columns == 1;

    // We need to calculate width of leftover space after the columns are added/removed

    let leftover = 40; // Leftover is percentage of with of the columns that can be added
    let numberOfColumns = 4; // Number of default, always shown columns
    if(showBracket) {
      leftover = leftover - 20;
      numberOfColumns++;

    }
    if(showGender) {
      leftover = leftover - 10;
      numberOfColumns++;
    }
    if(showPace) {
      leftover = leftover - 10;
      numberOfColumns++;
    }
    leftover = leftover/numberOfColumns;

    let bracket = '';
    // if(isCenter) {
    //   bracket = bracketName + ' | ' + bracketRank;
    // }
    return (
      <div className={`row ${rowClass}`} style={{lineHeight}}>
        <MediaQuery query='(min-width: 580px)'>
          <div className='cell' style={getStyles(12, leftover)}>{data.rank}</div>
          <div className='cell' style={getStyles(30, leftover)}>{data.name}</div>
          <div className='cell' style={getStyles(8, leftover)}>{data.bib}</div>

          { settings.show_gender ?  <div className='cell' style={getStyles(10, leftover)}>{sex}</div> : null }
          {
            showBracket && <div className='cell' style={getStyles(10, leftover)}>{bracketName}</div>
          }
          {
            showBracket && <div className='cell' style={getStyles(9, leftover)}>{bracketRank}</div>
          }
          {
            showPace ?  <div className='cell' style={getStyles(9, leftover)}>{pace}</div> : null
          }
          <div className='cell' style={getStyles(10, leftover)}>{time}</div>
        </MediaQuery>

        <MediaQuery query='(max-width: 580px)'>
          <div className="mobile entry">
            <h3>{data.name}</h3>
            <FormattedMessage id='place-mobile' className='place' values={{rank: data.rank}} />
            <FormattedMessage id='time-mobile' className='time' values={{time}} />
          </div>
        </MediaQuery>
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./components/entry/Entry.js